import React, { useState, useEffect, useRef } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import HttpService from "../services/httpService";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import {
	FormControlLabel,
	RadioGroup,
	FormControl,
	Radio,
	Button,
    TextField,
	Grid,
	Modal,
	Box,
	Typography,
	Dialog,
	DialogActions,
	DialogContent
} from "@material-ui/core";
import { CSVLink } from "react-csv";
import XLSX from "xlsx";
import moment from "moment";
import { poFirstApproverName } from "../utils";

const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 850,
	},
	paper: {
		padding: theme.spacing(2),
		margin: "auto",
		maxWidth: 500,
	},
	report: {
		marginBottom: 20,
		alignItems: "center",
		justifyContent: "center",
	},
    date: {
		marginTop: 10,
		marginBottom: 10,
		paddingTop: 10,
		paddingBottom: 10,
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#1C375D",
		color: "#FFF2EB",
		fontWeight: "1000",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const Reports = (props) => {
	const classes = useStyles();
	const [poSoApproved, setPoSoApproved] = useState([]);
	const [radioValue, setRadioValue] = useState("Both");
	const csvButtonRef = useRef(null);
	const [csvData, setCsvData] = useState([]);
    const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [displayData, setDisplayData] = useState([]);
	const [page, setPage] = useState(0); // frontend uses 0-based indexing
	const [rowsPerPage, setRowsPerPage] = useState(50);
	const [totalCount, setTotalCount] = useState(0); // set from backend API
	const [isSubmitClicked, setIsSubmitClicked] = useState(false)
	const [PoClickedData, setPoClickedData] = useState([])
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const [openPoClickedData, setOpenPoClickedData] = useState([])
	const [soClickedData, setSoClickedData] = useState([])
	const [soModalOpen, setSoModalOpen] = useState(false)
	const [csvNewData, setCsvNewData] = useState([])
	const [orderId, setOrderId] = useState("")
	// Header for csv file
    const sheetHeader = [
		"Project No.",
		"SO/PO.",
		"Project Type Name",
		"Material Name",
		"Requester Name",
		"First Approver Name",
		"Final Approver Name",
		"Vendor Name",
		"Requested Qty",
		"Requested Rate",
		"Requested Value",
		"Standard Qty",
		"Standard Rate",
		"Standard Value",
		"Approved Qty",
		"Approved Rate",
		"Approve Value",
		"Impact Qty",
		"Impact Rate",
		"Impact Value",
		"Approval Date",
		 "Create Date"
	];

	const headers = [
		{ key: "projectCode", label: "Project No." },
		{ key: "projectType", label: "SO/PO." },
		{ key: "projectTypeName", label: "Project Type Name." },
		{ key: "itemName", label: "Material Name" },
        { key: "requesterName", label: "Requester Name" },
		{ key: "vendorName", label: "Vendor Name" },
		{ key: "originallyRequestedQty", label: "Requested Qty" },
		{ key: "originallyRequestedRate", label: "Requested Rate" },
		{ key: "originallyRequestedValue", label: "Requested Value" },
		{ key: "standardQuantity", label: "Standard Qty" },
		{ key: "standardRate", label: "Standard Rate" },
		{ key: "standardValue", label: "Standard Value" },
		{ key: "approvedQuantity", label: "Approved Qty" },
		{ key: "approvedRate", label: "Approved Rate" },
		{ key: "approvedValue", label: "Approve Value" },
		{ key: "impactQuantity", label: "Impact Qty" },
		{ key: "impactRate", label: "Impact Rate" },
		{ key: "impactValue", label: "Impact Value" },
        { key: "updatedAt", label: "Approval Date" },
		{ key: "createdAt", label: "Create Date" },
	];

    // Function to generate excel with multiple tabs
	const generateExcel = (data1, data2) => {
		try {
			const wb = XLSX.utils.book_new();
	
			const ws1 = XLSX.utils.aoa_to_sheet(
				[
					sheetHeader,
					...data1.map((item) => [
						item.projectCode || poFirstApproverName?.type,
						item.projectType,
						item.projectTypeName || "Open",
						item.itemName,
						item.requesterName,
						item.firstApproverName || poFirstApproverName?.firstApprover,
						item.finalApproverName || item.openPOApproverNameFinal,
						item.vendorName,
						item.originallyRequestedQty,
						item.originallyRequestedRate,
						item.originallyRequestedValue,
						item.standardQuantity,
						item.standardRate,
						item.standardValue,
						item.approvedQuantity,
						item.approvedRate,
						item.approvedValue,
						item.impactQuantity,
						item.impactRate,
						item.impactValue,
						item.updatedAt,
						item.createdAt || item.updatedAt,
					]),
				]
				// data1
			);
			XLSX.utils.book_append_sheet(wb, ws1, "Positive Impact");
	
			const ws2 = XLSX.utils.aoa_to_sheet([
				sheetHeader,
				...data2.map((item) => [
					item.projectCode || poFirstApproverName?.type,
					item.projectType,
					item.projectTypeName || "Open",
					item.itemName,
					item.requesterName,
					item.firstApproverName || poFirstApproverName?.firstApprover,
					item.finalApproverName || item.openPOApproverNameFinal,
					item.vendorName,
					item.originallyRequestedQty,
					item.originallyRequestedRate,
					item.originallyRequestedValue,
					item.standardQuantity,
					item.standardRate,
					item.standardValue,
					item.approvedQuantity,
					item.approvedRate,
					item.approvedValue,
					item.impactQuantity,
					item.impactRate,
					item.impactValue,
					item.updatedAt,
				]),
			]);
			XLSX.utils.book_append_sheet(wb, ws2, "Negative Impact");
	
			const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });
	
			const s2ab = (s) => {
				const buf = new ArrayBuffer(s.length);
				const view = new Uint8Array(buf);
				for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
				return buf;
			};
	
			const blob = new Blob([s2ab(wbout)], {
				type: "application/octet-stream",
			});
			const url = URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "Standard_Rate_Approval_Report.xlsx");
			document.body.appendChild(link);
			link.click();
		} catch (error) {
			console.error(error);
			props.setSnackInfo("Something went wrong", "error");
		}
	};

	// Function to handle the radio Change for PO & SO
	const handleRadioChange = (event) => {
        setStartDate("");
		setEndDate("");
		setRadioValue(event.target.value);
	};

	// getting procurements order details approved by operation head
	const getAllProcurementsApprovedByOperationHead = async (page,rowsPerPage, startDate,endDate) => {
		props.setLoading(true);
		try {
			const response =
				await HttpService.getAllProcurementsDetailsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
			setPoSoApproved(response.data.data);
			setDisplayData(response.data.data);
			setTotalCount(response?.data.total)
			let arr = response?.data?.data
                // .filter((el) => el.approvedRate > el.standardRate)
				// .sort((a, b) => {
				// 	const dateA = moment(a.updatedAt, "DD/MM/YYYY", true);
				// 	const dateB = moment(b.updatedAt, "DD/MM/YYYY", true);
				// 	if (dateA.isValid() && dateB.isValid()) {
				// 		return dateB.toDate() - dateA.toDate();
				// 	} else {
				// 		return 0; // Handle invalid dates as needed
				// 	}
				// });
			setDisplayData(arr);
		} catch (error) {
			console.error(error);
			props.setSnackInfo("Couldn't get raised po details", "error");
		}
		props.setLoading(false);
	};

	// getting service order details approved by operation head
	const getServiceOrderDetailsApprovedByOperationHead = async (page,rowsPerPage, startDate,endDate) => {
		props.setLoading(true);
		try {
			const response = await HttpService.getServiceOrderDetailsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
            setPoSoApproved(response.data.data);
			setTotalCount(response?.data.total)
			let arr = response.data.data
                // .filter((el) => el.approvedRate > el.standardRate)
				// .sort((a, b) => {
				// 	const dateA = moment(a.updatedAt, "DD/MM/YYYY", true);
				// 	const dateB = moment(b.updatedAt, "DD/MM/YYYY", true);
				// 	if (dateA.isValid() && dateB.isValid()) {
				// 		return dateB.toDate() - dateA.toDate();
				// 	} else {
				// 		return 0; // Handle invalid dates as needed
				// 	}
				// });
			setDisplayData(arr);
		} catch (error) {
			console.error(error);
			props.setSnackInfo("Couldn't get raised po details", "error");
		}
		props.setLoading(false);
	};

    // getting service order details and procurement details approved by operation head
	const getSoPoApprovedByOperationHead = async (page,rowsPerPage, startDate,endDate) => {
		// props.setLoading(true);
		try {
			props.setLoading(true);
			const soApproved =[];
			const poApproved =
				await HttpService.getAllProcurementsAndServiceDetailsApprovedByOperationHead(page,rowsPerPage,startDate,endDate);
			// const newArray = await soApproved?.data.concat(poApproved?.data?.data);
			setPoSoApproved(poApproved.data.data);
			setTotalCount(poApproved?.data.totalCount)
			let arr = poApproved?.data?.data
                // .filter((el) => el.approvedRate > el.standardRate)
				// .sort((a, b) => {
				// 	const dateA = moment(a.updatedAt, "DD/MM/YYYY", true);
				// 	const dateB = moment(b.updatedAt, "DD/MM/YYYY", true);
				// 	if (dateA.isValid() && dateB.isValid()) {
				// 		return dateB.toDate() - dateA.toDate();
				// 	} else {
				// 		return 0; // Handle invalid dates as needed
				// 	}
				// });
			setDisplayData(arr);
			props.setLoading(false);
		} catch (error) {
			console.error("Error - ", error);
		}
		// props.setLoading(false);
	};

	// Function to download csv file
	const csvDownloadHandler = (csvNewData) => {
        props.setLoading(true);
		try {
			const negativeImpactArray = [];
			const positiveImpactArray = [];
			// const csvArray = displayData.map((el) => ({
			// 	...el,
			// 	updatedAt: new Date(el.updatedAt).toLocaleDateString(),
			// }));
			for (let i = 0; i < csvNewData.length; i++) {
				if (csvNewData[i].approvedRate < csvNewData[i].standardRate) {
					positiveImpactArray.push(csvNewData[i]);
				} else if (
					csvNewData[i].approvedRate > csvNewData[i].standardRate
				) {
					negativeImpactArray.push(csvNewData[i]);
				}
			}
			// setCsvData(csvArray);
            negativeImpactArray.sort((a, b) => {
				const dateA = moment(a.updatedAt, "DD/MM/YYYY", true);
				const dateB = moment(b.updatedAt, "DD/MM/YYYY", true);
				if (dateA.isValid() && dateB.isValid()) {
					return dateB.toDate() - dateA.toDate();
				} else {
					return 0; // Handle invalid dates as needed
				}
			});
			positiveImpactArray.sort((a, b) => {
				const dateA = moment(a.updatedAt, "DD/MM/YYYY", true);
				const dateB = moment(b.updatedAt, "DD/MM/YYYY", true);
				if (dateA.isValid() && dateB.isValid()) {
					return dateB.toDate() - dateA.toDate();
				} else {
					return 0; // Handle invalid dates as needed
				}
			});
			generateExcel(negativeImpactArray, positiveImpactArray);
			// downloadExcel();
		} catch (error) {
			console.error(error);
		}
        props.setLoading(false);
	};

	const downloadExcel = () => {
		setLoading(true);
		try {
			setTimeout(() => {
				csvButtonRef.current.link.click();
			});
		} catch (err) {
			console.error(err.message);
		}
		setLoading(false);
	};

    // Funciton to clear the date filter
	const clearDateFilterHandler = () => {
		props.setLoading(true);
		try {
			setStartDate("");
			setEndDate("");
            if (radioValue === "Both") {
				getSoPoApprovedByOperationHead(page,rowsPerPage ,startDate,endDate);
			} else {
				setRadioValue("Both");
			}
		} catch (error) {
			console.error("Error ->", error);
		}
		props.setLoading(false);
	};

	// Function to filter data based on dates
	const handleDateFilter = () => {
		props.setLoading(true);
		try {
			// const filteredArray = displayData.filter((el) => {
			// 	let itemDate = moment(el?.updatedAt, "DD/MM/YYYY", true); // Parse the date using Moment.js
            //     if (!itemDate.isValid()) {
			// 		console.error("Invalid date:", el?.updatedAt);
			// 		return false; // Handle invalid dates as needed
			// 	}

			// 	let selectedStartDate = new Date(startDate);
			// 	let selectedEndDate = new Date(endDate);

			// 	// Adjust selectedEndDate to the end of the day
			// 	selectedEndDate.setHours(23, 59, 59, 999);

			// 	// Extract the date part only for comparison
			// 	const itemDateWithoutTime = moment(itemDate).startOf("day");
			// 	const selectedStartDateWithoutTime =
			// 		moment(selectedStartDate).startOf("day");
			// 	const selectedEndDateWithoutTime =
			// 		moment(selectedEndDate).startOf("day");

            //     return (
            //         itemDateWithoutTime >= selectedStartDateWithoutTime &&
            //         itemDateWithoutTime <= selectedEndDateWithoutTime
            //     );
			// });
			// setDisplayData(filteredArray);
				if (radioValue === "PO") {
					getAllProcurementsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
				} else if (radioValue === "SO") {
					getServiceOrderDetailsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
				} else if (radioValue === "Both") {
					getSoPoApprovedByOperationHead(page,rowsPerPage ,startDate,endDate);
				}

		} catch (error) {
			console.error("Error ->", error);
		}
		props.setLoading(false);
	};

	useEffect(() => {
		if (radioValue === "PO") {
			getAllProcurementsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
		} else if (radioValue === "SO") {
			getServiceOrderDetailsApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
		} else if (radioValue === "Both") {
			getSoPoApprovedByOperationHead(page,rowsPerPage, startDate,endDate);
		}
	}, [radioValue,rowsPerPage,page]);


	const getProjectsScopedData = async (projectId,type,clickedOrderId) => {
		props.setLoading(true);
		try {
			const response = await HttpService.getProjectsScopedData(projectId)
			handleDownloadExcelClick(projectId,response.data.result,type,clickedOrderId)
			// setPoClickedData(response.data.result)
			// setOpen(true)
		} catch (error) {
			console.log(error)
			props.setSnackInfo(error?.response?.data?.message ?? "Error while fetching project scope data", "error")
		}
		props.setLoading(false);
	}
// Function to download Excel and open PO/SO modal
const handleDownloadExcelClick = async (selectedProject, overviewData, type, clickedOrderId) => {
	try {
	  props.setLoading(true);
  
	  const response = await HttpService.getProjectExcelFileData(
		{ _id: selectedProject },
		{ overview_data: overviewData }
	  );
  
	  const data = response?.data;
  
	  if (type === "PO") {
		const result = data?.procurements.filter(item => item.orderId === clickedOrderId);
		setPoClickedData(result || []);

	  } else if (type === "SO") {
		const result = data?.service_orders.filter(item => item.orderId === clickedOrderId);
		setPoClickedData(result || []);
	  }
  
	  setOpen(true);
	} catch (error) {
	  console.error("Error fetching Excel data:", error);
	} finally {
	  props.setLoading(false);
	}
  };
  
  // Function to get open PO data
  const getOpenPoData = async (id,clickedOrderId) => {
	try {
	  props.setLoading(true);
	  const response = await HttpService.getOpenPoData(id);
	  const data = response?.data?.data || [];
	  const result = data?.filter(item => item.orderId === clickedOrderId);
	  setPoClickedData(result || []);
	  setOpen(true);
  
	  console.log("Open PO Response:", data);
	} catch (error) {
	  console.error("Error fetching open PO data:", error);
	}
	props.setLoading(false);

  };

  const getAllProcurementDetailsApprovedByOperationHeadWithOutPagination = async (startDate, endDate) => {
    try {
        props.setLoading(true);
        const response = await HttpService.getAllProcurementDetailsApprovedByOperationHeadWithOutPagination(startDate, endDate);
        
        // Create a download link for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Procurement_Impact_Report.xlsx');
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        props.setLoading(false);
    } catch (error) {
        console.error("Error downloading report:", error);
        props.setLoading(false);
        // Handle error (show toast message, etc.)
    }
};
  
const getAllServiceOrderDetailsApprovedByOperationHeadWithOutPagination = async (startDate,endDate) => {
	try {
        props.setLoading(true);
        const response = await HttpService.getAllServiceOrderDetailsApprovedByOperationHeadWithOutPagination(startDate, endDate);
        
        // Create a download link for the blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ServiceOrder_Impact_Report.xlsx');
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        props.setLoading(false);
    } catch (error) {
        console.error("Error downloading report:", error);
        props.setLoading(false);
        // Handle error (show toast message, etc.)
    }
  }; 

  const getAllServiceOrderAndProcurementDetailsApprovedByOperationHeadWithOutPagination = async (startDate,endDate) => {
	try {
	  props.setLoading(true);
	  const response = await HttpService.getAllServiceOrderAndProcurementDetailsApprovedByOperationHeadWithOutPagination(startDate,endDate);
	  const url = window.URL.createObjectURL(new Blob([response.data]));
	  const link = document.createElement('a');
	  link.href = url;
	  link.setAttribute('download', 'SO_PO_Impact_Report.xlsx');
	  document.body.appendChild(link);
	  link.click();
	  
	  // Clean up
	  link.parentNode.removeChild(link);
	  window.URL.revokeObjectURL(url);
	  
	  props.setLoading(false);
	} catch (error) {
	  console.error("Error fetching open PO data:", error);
	}
	props.setLoading(false);
  }; 


	return (
		<div>
			<div className={classes.report}>
				<Paper className={classes.paper}>
					<center>
						<h2>
                            {`${
								radioValue === "PO"
									? "Procurement"
									: radioValue === "SO"
									? "Service"
									: "Procurement & Service"
							}`}{" "}
							Order Report
						</h2>
					</center>
				</Paper>
			</div>
			<div style={{ alignSelf: "center" }}>
				<FormControl component="fieldset">
					<RadioGroup
						aria-label="type"
						name="type"
						value={radioValue}
						onChange={handleRadioChange}
					>
						<div className="modal-header-radio">
                            <FormControlLabel value="Both" control={<Radio />} label="Both" />
							<FormControlLabel value="PO" control={<Radio />} label="PO" />
							<FormControlLabel value="SO" control={<Radio />} label="SO" />
						</div>
						<div style={{ marginBottom: 10 }}>
							<CSVLink
								headers={headers}
								filename={
									`${
										radioValue === "PO" ? "Procurement" : "Service"
									} Order Report` + ".csv"
								}
								data={csvData}
								ref={csvButtonRef}
							/>
							<Button
								onClick={()=>{
									if (radioValue === "PO") {
										getAllProcurementDetailsApprovedByOperationHeadWithOutPagination(startDate, endDate);
									} else if (radioValue === "SO") {
										getAllServiceOrderDetailsApprovedByOperationHeadWithOutPagination(startDate, endDate)
									} else if (radioValue === "Both") {
										getAllServiceOrderAndProcurementDetailsApprovedByOperationHeadWithOutPagination(startDate, endDate);
									}
								}
								}
								style={{
									marginLeft: 10,
									backgroundColor: "#355025",
									color: "#FFF2EB",
								}}
								variant="contained"
								color="success"
							>
								Download Impact CSV
							</Button>
						</div>
					</RadioGroup>
				</FormControl>
			</div>
            <Paper className={classes.date}>
				<Grid
					container
					style={{
						display: "flex",
						alignItems: "center",
						width: "70vw",
						marginLeft: 25,
					}}
				>
					<Grid item md={3} xs={12}>
						<TextField
							id="date"
							name="startDate"
							label="Approval Start Date"
							type="date"
							value={startDate}
							onChange={(e) => setStartDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							className={classes.textField}
						/>
					</Grid>
					<Grid item md={1} xs={12}></Grid>
					<Grid item md={3} xs={12}>
						<TextField
							id="date"
							name="endDate"
							label="Approval End Date"
							type="date"
							value={endDate}
							onChange={(e) => setEndDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							className={classes.textField}
						/>
					</Grid>
					<Grid item md={3} xs={12}>
						<Button
							variant="contained"
							color="primary"
							disabled={!startDate || !endDate}
							onClick={handleDateFilter}
							style={{ marginLeft: 10 }}
						>
							Submit
						</Button>
					</Grid>
					<Grid item md={2} xs={12}>
						<Button
							variant="contained"
							color="secondary"
							onClick={()=>{
								clearDateFilterHandler()
								// handleDateFilter()
							}}
						>
							Clear Filter
						</Button>
					</Grid>
				</Grid>
			</Paper>
			<TablePagination
				component="div"
				rowsPerPageOptions={[50, 100, 200, 500]}
				count={totalCount} // This should come from backend API
				page={page}
				onPageChange={(event, newPage) => setPage(newPage)}
				rowsPerPage={rowsPerPage}
				onRowsPerPageChange={(event) => {
					setRowsPerPage(parseInt(event.target.value, 10));
					setPage(0);
				}}
	    />	
			<TableContainer component={Paper}>
		<Table
			className={classes.table}
			size="small"
			aria-label="customized table"
		>
			<TableHead>
				<TableRow>
					<StyledTableCell>Sl No</StyledTableCell>
					<StyledTableCell>Project No</StyledTableCell>
					<StyledTableCell>SO/PO</StyledTableCell>
					<StyledTableCell>Project Type Name</StyledTableCell>
					<StyledTableCell>Material Name</StyledTableCell>
					<StyledTableCell>Requester Name</StyledTableCell>
					<StyledTableCell>First Approver Name</StyledTableCell>
					<StyledTableCell>Final Approver Name</StyledTableCell>
					<StyledTableCell>Vendor Name</StyledTableCell>
					<StyledTableCell>Requested Qty</StyledTableCell>
					<StyledTableCell>Requested Rate</StyledTableCell>
					<StyledTableCell>Requested Value</StyledTableCell>
					<StyledTableCell>Standard Qty</StyledTableCell>
					<StyledTableCell>Standard Rate</StyledTableCell>
					<StyledTableCell>Standard Value</StyledTableCell>
					<StyledTableCell>Approved Qty</StyledTableCell>
					<StyledTableCell>Approved Rate</StyledTableCell>
					<StyledTableCell>Approved Value</StyledTableCell>
					<StyledTableCell>Impact Qty</StyledTableCell>
					<StyledTableCell>Impact Rate</StyledTableCell>
					<StyledTableCell>Impact Value</StyledTableCell>
					<StyledTableCell>Approval Date</StyledTableCell>
					<StyledTableCell>Created Date</StyledTableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{displayData?.map((data, i) => (
				<StyledTableRow key={page * rowsPerPage + i + 1}>
						<StyledTableCell>{page * rowsPerPage + i + 1}</StyledTableCell>
						<StyledTableCell >
						{data?.projectCode || poFirstApproverName?.type || "N/A"}</StyledTableCell>
						<StyledTableCell 						style=
						{{textDecoration :"underLine",cursor:"pointer"}}
						onClick={()=>{
							if(((data?.orderType==="PO" && data?.projectCode) || data?.orderType==="SO")){
								getProjectsScopedData(data?.projectId,data?.orderType,data?.projectType)
							}else{
								getOpenPoData(data._id, data?.projectType)
							}
						}}>{data?.projectType || "N/A"}</StyledTableCell>
						<StyledTableCell>{data?.projectTypeName || "Open"}</StyledTableCell>
						<StyledTableCell>{data?.itemName || "N/A"}</StyledTableCell>
						<StyledTableCell>
							{data?.requesterName || "N/A"}
						</StyledTableCell>
						<StyledTableCell style={{ textAlign: "center" }}>
						{data?.standardRate>data?.approvedRate?"-":data?.firstApproverName || poFirstApproverName?.firstApprover || "N/A"}
						</StyledTableCell>
						<StyledTableCell>
						{data?.standardRate>data?.approvedRate? poFirstApproverName?.firstApprover :data?.finalApproverName || data?.openPOApproverNameFinal || "N/A" }
						</StyledTableCell>
						<StyledTableCell>{data?.vendorName || "N/A"}</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.originallyRequestedQty).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.originallyRequestedRate).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.originallyRequestedValue).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.standardQuantity).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.standardRate).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.standardValue).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.approvedQuantity).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.approvedRate).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.approvedValue).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{isNaN(parseFloat(data?.impactQuantity).toFixed(2))
								? "N/A"
								: parseFloat(data?.impactQuantity).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.impactRate).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{parseFloat(data?.impactValue).toFixed(2)}
						</StyledTableCell>
						<StyledTableCell>
							{
								
								radioValue === "SO"? moment(data?.updatedAt).format('DD/MM/YYYY') :data?.updatedAt
								// ? new Date(data.updatedAt).toLocaleDateString()
								// : ""
							}
						</StyledTableCell>
						<StyledTableCell>
							{
								data?.createdAt || data?.updatedAt
								// ? new Date(data.updatedAt).toLocaleDateString()
								// : ""
							}
						</StyledTableCell>
					</StyledTableRow>
				))}
			</TableBody>
		</Table>
		</TableContainer>

      {/* Dialog Box for showing PO Click Data */}
      <Dialog
        open={open}
        onClose={() => {
        //   setPostModelIsOpen(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "50%", // Set custom width
            maxHeight: "50vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
		<TableContainer component={Paper}>
      {/* <Typography variant="h6" sx={{ p: 2 }}>
        Procurement PO Table
      </Typography> */}
      <Table>
        <TableHead>
          <StyledTableRow>
            <StyledTableCell>Sl. No</StyledTableCell>
            <StyledTableCell>Order ID</StyledTableCell>
            <StyledTableCell>PO/SO Status</StyledTableCell>
            <StyledTableCell>Vendor Name</StyledTableCell>
            <StyledTableCell>Material Code</StyledTableCell>
            {/* <StyledTableCell>Scope Name</StyledTableCell> */}
            <StyledTableCell>Material Status</StyledTableCell>
            {/* <StyledTableCell>Vendor Price</StyledTableCell>
            <StyledTableCell>Requested Price</StyledTableCell> */}
            <StyledTableCell>Material Unit</StyledTableCell>
            <StyledTableCell>Qty</StyledTableCell>
            <StyledTableCell>Requested Qty</StyledTableCell>
            <StyledTableCell>Material Total Value</StyledTableCell>
            <StyledTableCell>PO/SO Value</StyledTableCell>
            <StyledTableCell>Created At</StyledTableCell>
			<StyledTableCell>Invoices</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {PoClickedData.length>0 && PoClickedData?.map((po, i) => {
            let poValue = 0;

            return po.materials.map((mat, j) => {
                const materialTotalValue =
                Number(mat?.requestedQuantity || mat?.requestedQuantity) *
                Number(mat?.requestedPrice || mat.price);

              poValue += materialTotalValue;

              const isLastRow = j === po.materials.length - 1;
			  const isFirstRow = j === 0;


              return (
                <StyledTableRow key={`${i}-${j}`}>
                  <StyledTableCell>{j === 0 ? i + 1 : ""}</StyledTableCell>
                  <StyledTableCell>{j === 0 ? po.orderId : ""}</StyledTableCell>
                  <StyledTableCell>{j === 0 ? po.status : ""}</StyledTableCell>
                  <StyledTableCell>{j === 0 ? po.vendorId?.name : ""}</StyledTableCell>
                  <StyledTableCell>{mat?.materialId?.name || ""}</StyledTableCell>
                  {/* <StyledTableCell>{po.scopeId?.name || mat.scopeId?.name || ""}</StyledTableCell> */}
                  <StyledTableCell>{mat?.status || ""}</StyledTableCell>
                  {/* <StyledTableCell>{mat?.pricePerUnit || ""}</StyledTableCell>
                  <StyledTableCell>{mat?.requestedPrice || po.requestedPrice || ""}</StyledTableCell> */}
                  <StyledTableCell>{mat?.unitId?.name || ""}</StyledTableCell>
                  <StyledTableCell>{mat?.quantity || ""}</StyledTableCell>
                  <StyledTableCell>{mat?.requestedQuantity || ""}</StyledTableCell>
                  <StyledTableCell>{materialTotalValue.toFixed(2)}</StyledTableCell>
                  <StyledTableCell>
                    {isFirstRow ? poValue.toFixed(2) : ""}
                  </StyledTableCell>
                  <StyledTableCell>
				  {/* {moment(po.createdAt).format("DD-MM-YYYY") || " "} */}
                    {isFirstRow
                      ? moment(po.createdAt).format("DD-MM-YYYY")
                      : ""}
                  </StyledTableCell>
				  <StyledTableCell>
					{j === 0 && (po?.poLink || po?.soLink )? (
						<a
						href={po.poLink ||po.soLink}
						download
						target="_blank"
						rel="noopener noreferrer"
						style={{ textDecoration: "none", color: "#1976d2" }}
						>
						Download 
						</a>
					) : (
						""
					)}
				</StyledTableCell>

                </StyledTableRow>
              );
            });
          })}
        </TableBody>
      </Table>
    </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
				handleClose()
            }}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>		

     {/* Dialog Box for showing SO Click Data */}
		





		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(Reports);